import React from 'react'

import { Input } from '@ui/components/Input'
import { ArrowIcon } from '@ui/icons/Arrow.icon'
import { IconFCType } from '@ui/icons/types'

import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

interface InputData<T> {
  value: T | null
  label?: string
  error?: boolean
  hint?: string
  placeholder?: string
  disabled?: boolean
  icon?: IconFCType
  onChange?: (value: string | null) => void
}

export interface ModalBodyTableFromToProps<T> {
  inputIcon?: IconFCType
  middleIcon?: IconFCType
  from?: InputData<T>
  to?: InputData<T>
}

export const ModalBodyTableFromTo = <T,>(props: ModalBodyTableFromToProps<T>) => {
  const { from, to, inputIcon } = props
  const FromIcon = from?.icon ?? inputIcon
  const ToIcon = to?.icon ?? inputIcon
  const { middleIcon: MiddleIcon = ArrowIcon.Right } = props

  const isMobile = useWindowResize()

  const inputType = typeof from?.value === 'number' ? 'number' : 'text'

  const getLabelProps = (data?: InputData<T>) => {
    const label = data?.label
    const placeholder = data?.placeholder
    const effectiveLabel = label ?? placeholder

    if (effectiveLabel) {
      return { label: effectiveLabel, placeholder }
    }
    return {}
  }

  return (
    <Box fullWidth flex align='center' direction={isMobile ? 'column' : 'row'} gap='x8'>
      <Input
        {...getLabelProps(from)}
        type={inputType}
        fullWidth
        error={from?.error}
        hint={from?.hint}
        disabled={from?.disabled}
        onChange={(e) => from?.onChange?.(e.target.value)}
        value={from?.value ? String(from?.value) : ''}
        readOnly={!from?.onChange}
        rightIcon={FromIcon ? FromIcon : undefined}
      />
      {!isMobile && <MiddleIcon />}
      <Input
        {...getLabelProps(to)}
        type={inputType}
        fullWidth
        error={to?.error}
        hint={to?.hint}
        disabled={to?.disabled}
        onChange={(e) => to?.onChange?.(e.target.value)}
        value={to?.value ? String(to?.value) : ''}
        readOnly={!to?.onChange}
        rightIcon={ToIcon ? ToIcon : undefined}
      />
    </Box>
  )
}
